import { db } from '../firebase'
import firebase from 'firebase'
import { imageRef } from '../firebase'
import swal from 'sweetalert2/dist/sweetalert2.all.min.js'
import AdminCard from '../components/admin'

export const FETCH_MEMBERS = 'FETCH_MEMBERS'
export const FETCH_MEMBERS_LOADING = 'FETCH_MEMBERS_LOADING'
export const FETCH_MEMBERS_SUCCESS = 'FETCH_MEMBERS_SUCCESS'
export const ADD_MEMBER = 'ADD_MEMBER'
export const ADD_MEMBER_ERROR = 'ADD_MEMBER_ERROR'
export const ADD_MEMBER_SUCCESS = 'ADD_MEMBER_SUCCESS'
export const DELETE_MEMBER = 'DELETE_MEMBER'
export const DELETE_MEMBER_CONFIRM = 'DELETE_MEMBER_CONFIRM'
export const DELETE_MEMBER_SUCCESS = 'DELETE_MEMBER_SUCCESS'
export const MODIFY_MEMBER = 'MODIFY_MEMBER'
export const MODIFY_MEMBER_SUCCESS = 'MODIFY_MEMBER_SUCCESS'

export const fetchMembersSuccess = (members) => {
  return {
    type: FETCH_MEMBERS_SUCCESS,
    members,
  }
}

export const membersLoading = (bool) => {
  return {
    type: FETCH_MEMBERS_LOADING,
    isLoading: bool,
  }
}

export const fetchMembers = (cb) => {
  return (dispatch) => {
    dispatch(membersLoading(true))
    let members = {
      Adhérent: [],
      Honoraire: [],
      'de droit': [],
      Actif: [],
      Associé: [],
      Étudiant: [],
      error: [],
    }
    let membersType = [
      'Adhérent',
      'Honoraire',
      'de droit',
      'Actif',
      'Associé',
      'Étudiant',
      'error',
    ]
    if (
      sessionStorage.getItem('members') === null ||
      sessionStorage.getItem('members') === '' ||
      sessionStorage.getItem('members') === undefined
    ) {
      // console.log('Fetching')
      db.collection('members')
        .get()
        .then(
          function (doc) {
            membersType.forEach((type) => {
              if (type !== 'error') {
                members[type] = doc.docs
                  .filter((item) => {
                    if (item.data().member) {
                      return (
                        item.data().member.toLowerCase() === type.toLowerCase()
                      )
                    }
                  })
                  .map((x) => {
                    let member = {}
                    member = x.data()
                    member.id = x.id
                    return member
                  })
                  .sort((a, b) => {
                    return a.lastname.localeCompare(b.lastname)
                  })
              } else {
                members['error'] = doc.docs
                  .filter(
                    (item) =>
                      item.data().member !== 'Adhérent' &&
                      item.data().member !== 'Associé' &&
                      item.data().member !== 'Actif' &&
                      item.data().member !== 'de droit' &&
                      item.data().member !== 'Honoraire' &&
                      item.data().member !== 'Étudiant'
                  )
                  .map((x) => {
                    let member = {}
                    member = x.data()
                    member.id = x.id
                    return member
                  })
                // .sort((a, b) => {
                //   return a.lastname.localeCompare(b.lastname);
                // })
              }
            })
            console.log('firebase members')
            sessionStorage.setItem('members', JSON.stringify(members))
          },
          function (error) {
            console.error(error)
          }
        )
    } else {
      console.log('sessionStorage members')
      members = JSON.parse(sessionStorage.getItem('members'))
    }
    if (members !== []) {
      dispatch(fetchMembersSuccess(members))
      dispatch(membersLoading(false))
    }
  }
}

const reloadWithNewDb = () => {
  sessionStorage.members = ''
  window.location.reload(true)
  // console.log('reload')
}

export const addProfilePic = (
  {
    firstname,
    lastname,
    member,
    company,
    job,
    adress,
    cp,
    phone1,
    phone2,
    mobilephone,
    email,
    website1,
    website2,
    skills,
    id,
  } = this.props.item
) => {
  const sansAccent = (str) => {
    var accent = [
      /[\300-\306]/g,
      /[\340-\346]/g, // A, a
      /[\310-\313]/g,
      /[\350-\353]/g, // E, e
      /[\314-\317]/g,
      /[\354-\357]/g, // I, i
      /[\322-\330]/g,
      /[\362-\370]/g, // O, o
      /[\331-\334]/g,
      /[\371-\374]/g, // U, u
      /[\321]/g,
      /[\361]/g, // N, n
      /[\307]/g,
      /[\347]/g, // C, c
    ]
    var noaccent = [
      'A',
      'a',
      'E',
      'e',
      'I',
      'i',
      'O',
      'o',
      'U',
      'u',
      'N',
      'n',
      'C',
      'c',
    ]

    for (var i = 0; i < accent.length; i++) {
      str = str.replace(accent[i], noaccent[i])
    }
    return str
  }

  const urlExists = (url) => {
    var http = new XMLHttpRequest()
    http.open('HEAD', url, false)
    http.send()
    return http.status != 404
  }

  const getImageWithExtension = (firstname, lastname) => {
    if (
      urlExists(
        '/assets/photos/' +
          sansAccent(lastname).toUpperCase() +
          ' ' +
          firstname +
          '.jpg'
      )
    ) {
      return (
        '/assets/photos/' +
        sansAccent(lastname).toUpperCase() +
        ' ' +
        firstname +
        '.jpg'
      )
    } else {
      return '/assets/svg/user.svg'
    }
  }

  let fileName = id + '.jpg'
  let spaceRef = imageRef.child(fileName)
  let path = spaceRef.fullPath

  var getFileBlob = function (url, cb) {
    var xhr = new XMLHttpRequest()
    xhr.open('GET', url)
    xhr.responseType = 'blob'
    xhr.addEventListener('load', function () {
      cb(xhr.response)
    })
    xhr.send()
  }

  var blobToFile = function (blob, name) {
    blob.lastModifiedDate = new Date()
    blob.name = name
    return blob
  }

  var getFileObject = function (filePathOrUrl, cb) {
    getFileBlob(filePathOrUrl, function (blob) {
      cb(blobToFile(blob, id + '.jpg'))
    })
  }
  getFileObject(getImageWithExtension(firstname, lastname), (fileObject) => {
    let uploadTask = spaceRef.put(fileObject)

    uploadTask.on(
      'state_changed',
      (snapshot) => {
        // Observe state change events such as progress, pause, and resume
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        console.log('Upload is ' + progress + '% done')
        switch (snapshot.state) {
          case firebase.storage.TaskState.PAUSED: // or 'paused'
            console.log('Upload is paused')
            break
          case firebase.storage.TaskState.RUNNING: // or 'running'
            console.log('Upload is running')
            break
        }
      },
      (error) => {
        console.error(error)
      },
      () => {
        var downloadURL = uploadTask.snapshot.downloadURL
        return downloadURL
      }
    )
  })
}

export const modifyMembersSuccess = (bool) => {
  return {
    type: MODIFY_MEMBER_SUCCESS,
    bool,
  }
}

export const modifyMembersError = (error) => {
  return {
    type: MODIFY_MEMBER_SUCCESS,
    error,
  }
}

export const modifyMember = (id, member, prevMember) => {
  return (dispatch) => {
    // console.log(prevMember)
    swal({
      title: 'Êtes vous sûre?',
      text: "Il n'y aura pas de retour en arrière...",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Modifier',
    })
      .then(function (result) {
        if (result.dismiss === 'cancel') {
          swal('Annulé', "Le membre n'a pas été modifié.", 'error')
        } else {
          if (
            typeof member.profilpic === 'object' &&
            prevMember.profilpic !== ''
          ) {
            let spaceRef = imageRef.child(id)
            spaceRef
              .delete()
              .then(() => {
                let uploadTask = spaceRef.put(member.profilpic)
                uploadTask.on(
                  'state_changed',
                  (snapshot) => {
                    // Observe state change events such as progress, pause, and resume
                    // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                    var progress =
                      (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                    console.log('Upload is ' + progress + '% done')
                    switch (snapshot.state) {
                      case firebase.storage.TaskState.PAUSED: // or 'paused'
                        console.log('Upload is paused')
                        break
                      case firebase.storage.TaskState.RUNNING: // or 'running'
                        console.log('Upload is running')
                        break
                    }
                  },
                  (error) => {
                    console.log(error)
                    swal(
                      'Erreur',
                      'Une erreur est survenue, veuillez réessayer',
                      'error'
                    )
                  },
                  () => {
                    var downloadURL = uploadTask.snapshot.downloadURL
                    member.profilpic = downloadURL
                    db.collection('members')
                      .doc(id)
                      .update(member)
                      .then(() =>
                        swal(
                          'Ajouté',
                          'Le membre a été ajouté avec succès.',
                          'success'
                        ).then((result) => {
                          if (result.value) reloadWithNewDb()
                        })
                      )
                      .catch((err) => {
                        console.log(err)
                        swal(
                          'Erreur',
                          'Une erreur est survenue, veuillez réessayer',
                          'error'
                        )
                      })
                    return downloadURL
                  }
                )
              })
              .catch((err) => {
                console.log(err)
                if (err.code === 'storage/object-not-found') {
                  let spaceRef = imageRef.child(id)
                  let uploadTask = spaceRef.put(member.profilpic)
                  uploadTask.on(
                    'state_changed',
                    (snapshot) => {
                      // Observe state change events such as progress, pause, and resume
                      // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                      var progress =
                        (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                      console.log('Upload is ' + progress + '% done')
                      switch (snapshot.state) {
                        case firebase.storage.TaskState.PAUSED: // or 'paused'
                          console.log('Upload is paused')
                          break
                        case firebase.storage.TaskState.RUNNING: // or 'running'
                          console.log('Upload is running')
                          break
                      }
                    },
                    (error) => {
                      console.log(error)
                      swal(
                        'Erreur',
                        'Une erreur est survenue, veuillez réessayer',
                        'error'
                      )
                    },
                    () => {
                      var downloadURL = uploadTask.snapshot.downloadURL
                      member.profilpic = downloadURL
                      db.collection('members')
                        .doc(id)
                        .update(member)
                        .then(() =>
                          swal(
                            'Ajouté',
                            'Le membre a été ajouté avec succès.',
                            'success'
                          ).then((result) => {
                            if (result.value) reloadWithNewDb()
                          })
                        )
                        .catch((err) => {
                          console.log(err)
                          swal(
                            'Erreur',
                            'Une erreur est survenue, veuillez réessayer',
                            'error'
                          )
                        })
                      return downloadURL
                    }
                  )
                } else {
                  swal(
                    'Erreur',
                    'Une erreur est survenue, veuillez réessayer',
                    'error'
                  )
                }
              })
          } else if (prevMember.profilpic === '') {
            let spaceRef = imageRef.child(id)
            let uploadTask = spaceRef.put(member.profilpic)
            uploadTask.on(
              'state_changed',
              (snapshot) => {
                // Observe state change events such as progress, pause, and resume
                // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                var progress =
                  (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                console.log('Upload is ' + progress + '% done')
                switch (snapshot.state) {
                  case firebase.storage.TaskState.PAUSED: // or 'paused'
                    console.log('Upload is paused')
                    break
                  case firebase.storage.TaskState.RUNNING: // or 'running'
                    console.log('Upload is running')
                    break
                }
              },
              (error) => {
                console.log(error)
                swal(
                  'Erreur',
                  'Une erreur est survenue, veuillez réessayer',
                  'error'
                )
              },
              () => {
                var downloadURL = uploadTask.snapshot.downloadURL
                member.profilpic = downloadURL
                db.collection('members')
                  .doc(id)
                  .update(member)
                  .then(() =>
                    swal(
                      'Ajouté',
                      'Le membre a été ajouté avec succès.',
                      'success'
                    ).then((result) => {
                      if (result.value) reloadWithNewDb()
                    })
                  )
                  .catch((err) => {
                    console.log(err)
                    swal(
                      'Erreur',
                      'Une erreur est survenue, veuillez réessayer',
                      'error'
                    )
                  })
                return downloadURL
              }
            )
          } else {
            db.collection('members')
              .doc(id)
              .update(member)
              .then((result) => {
                swal('Mis à jour!', 'Le membre a été modifié.', 'success')
                  .then((result) => {
                    if (result.value) reloadWithNewDb()
                  })
                  .then(() => dispatch(modifyMembersSuccess(true)))
                  .catch(() => dispatch(modifyMembersSuccess(false)))
              })
          }
        }
      })
      .catch((err) => console.error(err))
  }
}

export const addMember = (member) => {
  return (dispatch) => {
    swal({
      title: 'Ajouter le membre ?',
      text: 'En cliquant sur Ajouter le membre sera ajouté à la base de données',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Ajouter',
    }).then(function (result) {
      if (result.dismiss === 'cancel') {
        swal('Annulé', "Le membre n'a pas été ajouté.", 'error')
      } else {
        let imgFile = member.profilpic
        delete member['id']
        let memberNoPP = { ...member }
        memberNoPP.profilpic = ''
        db.collection('members')
          .add(memberNoPP)
          .then(function (docRef) {
            if (docRef.id) {
              if (
                member.profilpic !== '' &&
                member.profilpic !== null &&
                member.profilpic !== undefined
              ) {
                let spaceRef = imageRef.child(docRef.id)
                let uploadTask = spaceRef.put(imgFile)
                uploadTask.on(
                  'state_changed',
                  (snapshot) => {
                    // Observe state change events such as progress, pause, and resume
                    // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                    var progress =
                      (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                    console.log('Upload is ' + progress + '% done')
                    switch (snapshot.state) {
                      case firebase.storage.TaskState.PAUSED: // or 'paused'
                        console.log('Upload is paused')
                        break
                      case firebase.storage.TaskState.RUNNING: // or 'running'
                        console.log('Upload is running')
                        break
                    }
                  },
                  (error) => {
                    swal(
                      'Erreur',
                      'Une erreur est survenue, veuillez réessayer',
                      'error'
                    )
                  },
                  () => {
                    var downloadURL = uploadTask.snapshot.downloadURL
                    db.collection('members').doc(docRef.id).update({
                      profilpic: downloadURL,
                    })
                    return downloadURL
                  }
                )
              }
              // console.log('Document written with ID: ', docRef.id)
              swal(
                'Ajouté',
                'Le membre a été ajouté avec succès.',
                'success'
              ).then((result) => {
                if (result.value) reloadWithNewDb()
              })
            }
          })
          .catch(function (error) {
            swal(
              'Erreur',
              'Une erreur est survenue, veuillez réessayer',
              'error'
            )
          })
      }
    })
  }
}

export const deleteMember = (id) => {
  return (dispatch) => {
    swal({
      title: 'Supprimer ce membre ?',
      text: 'En cliquant sur Supprimer, le membre sera supprimé. Cette action est irreversible',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Supprimer',
    }).then(function (result) {
      if (result.dismiss === 'cancel') {
        swal('Annulé', "Le membre n'a pas été supprimé.", 'error')
      } else {
        db.collection('members')
          .doc(id)
          .delete()
          .then(() => {
            swal(
              'Supprimé',
              'Le membre a été supprimé avec succès.',
              'success'
            ).then((result) => {
              if (result.value) reloadWithNewDb()
            })
          })
          .catch((err) => {
            swal(
              'Erreur',
              'Une erreur est survenue, veuillez réessayer',
              'error'
            )
          })
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/member.js